//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { conversion } from "@/tool";
import * as apis from '@/api';
import battleCaseDetail from './battleCaseDetail.vue';

export default {
  name: 'NewRoom',

  components: {
    'c-battleCaseDetail': battleCaseDetail
  },

  data() {
    return {
      caseData: [],
      joinCount: 2,
      isTeamMode: 0,
      isCrazyMode: 0,
      roomCount: 1,
      roomCountArr: [1, 2, 3, 4, 5],
      // 存储按选择顺序排列的盲盒队列，每个元素包含原始盲盒字段以及独一无二的 queueId
      selectedBoxQueue: [], 
      roomPassword: "",
      loading: false,
      current_case_title: "全部",
      case_detail_modal: {
        flag: false,
        caseInfo: {}
      },
      toggleCasePriceSortFlag: false
    }
  },
  props: {
    pkBoxList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    cases_types() {
      var list = this.pkBoxList.map(_ => _.caseType) || [];
      list.unshift('全部');
      var types = new Set(list);
      return types;
    },
    filteredCaseData() {
      if (!this.caseData) return [];
      return this.caseData.filter(_ => _.caseType == (this.current_case_title == '全部' ? _.caseType : this.current_case_title));
    },
    totalSelectedPrice() {
      return this.selectedBoxQueue.reduce((sum, item) => sum + Number(item.casePrice || 0), 0);
    },
    totalSelectedCount() {
      return this.selectedBoxQueue.length;
    },
  },
  created() {
    // 浅拷贝原始列表，不再对原始项进行 item.count = 0 的注入
    this.caseData = this.pkBoxList.slice();
  },
  methods: {
    reset() {
      this.loading = false;
    },
    close() {
      this.loading = false;
      this.$refs.newRoom.style.display = 'none';
      this.getUserInfo();
    },
    handleSwitchTeamMode(mode) {
      this.isTeamMode = mode;
      if (mode === 1) {
        this.joinCount = 4;
      } else {
        this.joinCount = 2;
      }
    },
    handleChangeJoinCount(val) {
      if (this.isTeamMode === 1) return;
      this.joinCount = val
    },
    handleChangeRoomCount(val) {
      this.roomCount = val
    },
    // 获取某个盲盒在当前选中队列里的数量，以便在右上角显示角标
    getMatchCountInQueue(id) {
      return this.selectedBoxQueue.filter(item => item.id === id).length;
    },
    // 选择箱子：直接推入顺序队列
    handleSelectBox(item) {
      if (this.totalSelectedCount >= 99) {
        this.$toast.error('所选箱子已达上限')
        return;
      }
      // 生成带唯一时间戳或随机特征的标识符，保证相同箱子连续点击时 key 唯一
      const queueItem = {
        ...item,
        queueId: `${item.id}_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`
      };
      this.selectedBoxQueue.push(queueItem);
    },
    // 取消选择：根据在序列中的特定索引移除（支持移除中间某一个，后面依次前移）
    handleCancelSelectByIndex(index) {
      this.selectedBoxQueue.splice(index, 1);
    },
    // 立即创建房间
    handleNewRoom() {
      if (this.loading) return;
      this.loading = true;

      // 直接从顺序序列抽取对应的商品 ID
      const caseIds = this.selectedBoxQueue.map(item => item.id);

      const data = {
        Count: 1,
        SeatCount: this.joinCount,
        CaseIds: caseIds,
        Password: this.roomPassword,
        IsTeamMode: this.isTeamMode,
        IsCrazyMode: this.isCrazyMode
      }

      this.$emit('createRoom', data);

      // 存储到本地，供下一次读取
      localStorage.setItem('lastCreate', JSON.stringify({
        joinCount: this.joinCount,
        roomPassword: this.roomPassword,
        // 保存当前的顺序队列结构
        selectedBoxQueue: this.selectedBoxQueue,
        isTeamMode: this.isTeamMode,
        isCrazyMode: this.isCrazyMode
      }))
    },
    // 获取上次选项
    lastCreateFunc() {
      let data = null
      try {
        data = JSON.parse(localStorage.getItem('lastCreate') || '')
      } catch { }
      if (data) {
        this.joinCount = data.joinCount
        this.roomPassword = data.roomPassword
        
        // 兼容老版本本地缓存数据或直接还原顺序队列
        if (data.selectedBoxQueue) {
          this.selectedBoxQueue = data.selectedBoxQueue;
        } else if (data.caseData) {
          // 老版本处理逻辑降级：如果只有旧版的 count，重组成队列
          const restoredQueue = [];
          data.caseData.forEach(item => {
            if (item.count > 0) {
              for (let i = 0; i < item.count; i++) {
                restoredQueue.push({
                  ...item,
                  queueId: `${item.id}_restored_${i}_${Math.random()}`
                });
              }
            }
          });
          this.selectedBoxQueue = restoredQueue;
        }

        if (data.isTeamMode !== undefined) {
          this.isTeamMode = data.isTeamMode;
          if (this.isTeamMode === 1) this.joinCount = 4;
        }
        if (data.isCrazyMode !== undefined) this.isCrazyMode = data.isCrazyMode;
      }
    },
    async openCaseDetailModal(item) {
      const case_info_response = await apis.api_CaseDetail(item.id);
      if (case_info_response.data.code !== 0) return;

      const respone = case_info_response.data.data;
      this.case_detail_modal.caseInfo = respone;
      var totalRate = this.case_detail_modal.caseInfo.items.map(_ => _.viewRate).reduce((a, b) => a + b, 0);
      this.case_detail_modal.caseInfo.items.forEach((item, index) => {
        item.viewRate = Math.ceil((item.viewRate / totalRate) * 10000) / 100;
      });
      this.case_detail_modal.flag = true;
    },
    getUserInfo() {
      userService.getUserInfo().then((res) => {
        window.$rootApp.$store.commit('user/updateInfo', res)
      })
    },
    toggleCasePriceOrder() {
      this.caseData.reverse();
      this.toggleCasePriceSortFlag = !this.toggleCasePriceSortFlag;
    },
    handleReset() {
      this.selectedBoxQueue = [];
    }
  },
  filters: {
    conversion
  }
}
